module.exports = __webpack_public_path__ + "img/coal-ore.7f8568d6.png";